import { View, Text } from 'react-native'
import { styles } from './ObserverItem.styles'
import { Player } from '@ppwr/poker'
import { PlayerAvatar } from '../../../../PlayerAvatar'

export interface ObserverItemProps {
  index: number
  player: Player
}

export const ObserverItem = ({ index, player }: ObserverItemProps) => {
  return (
    <View style={styles.container}>
      <PlayerAvatar key={`$player-avatar-1-${index}`} name={player.name} color={'Shades/Maroon 2'} invert size={3} />
      <Text style={styles.text}>{player.name}</Text>
    </View>
  )
}
